var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 703.4 721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2, .cls-8 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-1, .cls-3, .cls-9, .cls-6, .cls-7, .cls-8 {\n        opacity: .5;\n      }\n\n      .cls-1, .cls-3, .cls-10 {\n        fill: #f4b405;\n      }\n\n      .cls-2, .cls-11, .cls-5 {\n        opacity: .3;\n      }\n\n      .cls-2, .cls-5, .cls-12 {\n        fill: #44352a;\n      }\n\n      .cls-3, .cls-11, .cls-9, .cls-5, .cls-6, .cls-7 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14, .cls-7 {\n        fill: #f39d08;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M289.1,580.8c20.4-37.1,33.4-94.1,33.4-158.1s-.1-11.8-.3-17.5h59c-.2,5.8-.3,11.6-.3,17.5,0,64,13.1,121,33.4,158.1h-125.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.9,422.7c0-5.9.1-11.8.3-17.5h-59c.2,5.8.3,11.6.3,17.5,0,11.4-.4,22.6-1.2,33.5h0s28.4-17.4,60.8,0c-.8-10.9-1.2-22.1-1.2-33.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.9,405.2h-8.5c.2,5.8.3,11.6.3,17.5,0,64-10.3,121-26.4,158.1h18c10.2-37.1,16.8-94.1,16.8-158.1s0-11.8-.2-17.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.3,580.8h-31.2c-10.2-37.1-16.8-94.1-16.8-158.1s0-11.8.2-17.5h14.7c-.2,5.8-.3,11.6-.3,17.5,0,64,13.1,121,33.4,158.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M419.4,364.5c-3.5-3.5-5.5-8.3-5.5-13.3V75.9c0-5.1,2.1-10.1,5.8-13.6s8.7-5.4,13.9-5.2c104.2,4.8,248.6-1.6,250.1-1.6,5.1-.2,10.1,1.7,13.9,5.2,3.7,3.6,5.8,8.5,5.8,13.6,0,118.3-22.8,194.5-71.8,240-22.8,21.2-51.4,35.8-87.3,44.6-30,7.4-65.4,10.9-111.5,11.1h0c-5,0-9.8-2-13.3-5.5h0ZM451.6,95.5v236.5c76.1-2.2,122.8-16,154.4-45.3,38.2-35.4,57.3-97,59.5-192.8-40.3,1.4-134.6,4.2-213.9,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451.6,77.6v17.9c78.9,2.5,173.2-.2,213.9-1.6v-.2c.5-9.6-7.5-17.5-17.1-17.2-46.1,1.4-127.2,3.3-196.8,1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M451.6,332v-4.6c-.4,2.3-.4,3.9,0,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M665.5,93.7l-.4.2h.4c-2.2,95.8-21.3,157.3-59.5,192.7-31.6,29.3-78.3,43.2-154.4,45.3,5.3,9,35.7,4.4,35.7,4.4,205.7-2.6,178.2-242.7,178.2-242.7h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M414.4,354V78.9c0-5.1,2.1-10.1,5.8-13.6,3.7-3.5,8.7-5.4,13.9-5.2,104.2,4.8,248.6-1.6,250.1-1.6,5.1-.2,10.1,1.7,13.9,5.2,2.6,2.5,4.4,5.6,5.2,9-.4-4.5-2.4-8.7-5.7-11.9-3.7-3.5-8.7-5.4-13.9-5.2-1.5,0-145.9,6.4-250.1,1.6-5.1-.2-10.1,1.6-13.9,5.2-3.7,3.5-5.8,8.5-5.8,13.6v275.2c0,1.6.2,3.1.6,4.6,0-.6,0-1.1,0-1.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M466.4,362.7c-17.2.2-32.4,1.2-45.8,2.9,3.4,2.8,7.6,4.4,12.1,4.4h0c46-.2,81.5-3.7,111.5-11.1,35.9-8.8,64.5-23.4,87.3-44.6,25.7-23.8,44.2-56.2,56-98.6-20.8,63-75.8,145.3-221.1,147.1h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M283.9,364.4c-3.5,3.5-8.3,5.5-13.3,5.5h0c-46.1-.2-81.5-3.7-111.5-11.1-35.9-8.8-64.5-23.4-87.3-44.6C22.8,268.8,0,192.6,0,74.3c0-5.1,2.1-10.1,5.8-13.6,3.7-3.5,8.7-5.4,13.9-5.2,1.4,0,145.9,6.4,250.1,1.6,5.1-.2,10.1,1.7,13.9,5.2s5.8,8.5,5.8,13.6v275.2c0,5-2,9.8-5.5,13.3h0ZM251.8,95.5c-79.3,2.6-173.6-.2-213.9-1.6,2.2,95.8,21.3,157.3,59.5,192.8,31.6,29.3,78.3,43.2,154.4,45.3V95.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.8,77.5c-69.6,2.2-150.7.4-196.8-1-9.6-.3-17.6,7.6-17.1,17.2v.2c40.7,1.4,135,4.2,213.9,1.6v-17.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M251.8,327.4v4.6c.4-.7.4-2.3,0-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.9,93.7s-27.5,240.1,178.2,242.7c0,0,30.4,4.6,35.7-4.4-76.1-2.2-122.8-16-154.4-45.3-38.2-35.4-57.2-97-59.5-192.7h.4s-.4-.2-.4-.2h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.9,354c0,.6,0,1.1,0,1.7.4-1.5.6-3.1.6-4.6V75.9c0-5.2-2.1-10.1-5.8-13.6-3.7-3.6-8.7-5.4-13.9-5.2-104.2,4.8-248.6-1.6-250.1-1.6-5.1-.2-10.1,1.7-13.9,5.2-3.3,3.2-5.3,7.4-5.7,11.9.9-3.4,2.7-6.5,5.2-9,3.7-3.5,8.7-5.4,13.9-5.2,1.4,0,145.9,6.4,250.1,1.6,5.1-.2,10.1,1.7,13.9,5.2,3.7,3.6,5.8,8.5,5.8,13.6v275.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.9,362.7c-145.4-1.7-200.3-84.1-221.1-147.1,11.8,42.5,30.3,74.8,56,98.6,22.8,21.2,51.4,35.8,87.3,44.6,30,7.4,65.4,10.9,111.5,11.1h0c4.4,0,8.7-1.6,12.1-4.4-13.4-1.6-28.5-2.6-45.8-2.9h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138.4,0c-5.1,29.5-7.9,60.5-7.9,92.6,0,192.3,99,348.2,221.1,348.2s221.1-155.9,221.1-348.2S569.9,29.5,564.8,0H138.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138.4,0c-5.1,29.5-7.9,60.5-7.9,92.6,0,192.3,99,348.2,221.1,348.2s221.1-155.9,221.1-348.2S569.9,29.5,564.8,0H138.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M564.8,0h-79.7c3.2,29.5,5,60.5,5,92.6,0,192.3-62,348.2-138.4,348.2,122.1,0,221.1-155.9,221.1-348.2S569.9,29.5,564.8,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "354.7 74.1 383.6 132.8 448.4 142.2 401.6 187.9 412.6 252.5 354.7 222 296.7 252.5 307.8 187.9 260.9 142.2 325.7 132.8 354.7 74.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.1,92.6c0-32,1.7-63.1,4.9-92.6h-54.5c-4.5,29.5-7,60.5-7,92.6,0,192.3,87.3,348.2,195,348.2-76.5,0-138.4-155.9-138.4-348.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.1,60.2c-25.7,0-46.5-20.8-46.5-46.5,0,25.7-20.8,46.5-46.5,46.5,25.7,0,46.5,20.8,46.5,46.5,0-25.7,20.8-46.5,46.5-46.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M255.6,106.7c-10.2,0-18.4-8.2-18.4-18.4,0,10.2-8.2,18.4-18.4,18.4,10.2,0,18.4,8.2,18.4,18.4,0-10.2,8.2-18.4,18.4-18.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.5,6.9c116,0,210.1-3.1,210.1-6.9H138.4c0,3.8,94.1,6.9,210.1,6.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M441,580.8h-178.6c-23.6,0-42.7,19.1-42.7,42.7h264c0-23.6-19.1-42.7-42.7-42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.4,584h178.6c22.5,0,40.9,17.4,42.6,39.5h.1c0-23.6-19.1-42.7-42.7-42.7h-178.6c-23.6,0-42.7,19.1-42.7,42.7h.1c1.6-22.1,20.1-39.5,42.6-39.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M483.7,623.5h-47.8c0-23.6-12.2-42.7-27.2-42.7h32.3c23.6,0,42.7,19.1,42.7,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.1,580.8h-35.3c-23.6,0-42.7,19.1-42.7,42.7h35.3c0-23.6,19.1-42.7,42.7-42.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 146.7,
    y: 623.5,
    width: 409.9,
    height: 84,
    rx: 3.9,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M552.7,679.4H150.7c-2.2,0-3.9-1.8-3.9-4v28.2c0,2.2,1.8,4,3.9,4h402c2.2,0,4-1.8,4-4v-28.2c0,2.2-1.8,4-4,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M150.7,707.6h24.7c-9.3,0-18.4-.4-27.4-1.1.7.7,1.7,1.1,2.7,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M552.7,623.5h-122.9c-19,92.9-125.6,84-254.4,84h377.2c2.2,0,4-1.8,4-4v-76.2c0-2.2-1.8-4-4-4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.7,623.5H150.7c-2.2,0-3.9,1.8-3.9,4v5.1c0-2.2,1.8-4,3.9-4h402c2.2,0,4,1.8,4,4v-5.1c0-2.2-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.2,
    y: 686.4,
    width: 472.9,
    height: 34.6,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.2,716.5H120.2c-2.8,0-5-2.2-5-5v4.5c0,2.8,2.2,5,5,5h463c2.8,0,5-2.2,5-5v-4.5c0,2.8-2.2,5-5,5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.2,686.4H120.2c-2.8,0-5,2.2-5,5v4.6c0-2.8,2.2-5,5-5h463c2.8,0,5,2.2,5,5v-4.6c0-2.8-2.2-5-5-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.2,686.4h-132c2.8,0,5,2.2,5,5v24.7c0,2.8-2.2,5-5,5h132c2.8,0,5-2.2,5-5v-24.7c0-2.8-2.2-5-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.6,716v-24.7c0-2.8,2.2-5,5-5h-71.8c-2.8,0-5,2.2-5,5v24.7c0,2.8,2.2,5,5,5h71.8c-2.8,0-5-2.2-5-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.7,623.5h264c0-2.6-.2-5.2-.7-7.7H220.4c-.4,2.5-.7,5.1-.7,7.7Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M269.6,303.8c0-7.2,1.9-12.9,5.5-17.1,3.6-4.2,8.4-6.4,14.4-6.5,4.3,0,8.2,1.3,11.7,3.9,3.4,2.6,5.6,6.8,6.5,12.4h-8.8c-.6-2.6-1.7-4.5-3.3-5.7-1.6-1.2-3.6-1.8-6.1-1.8-3.2,0-5.8,1.4-7.7,4-1.9,2.7-2.9,6.3-3,10.8,0,4.4,1,7.9,3,10.6,1.9,2.6,4.4,4,7.7,4,2.3,0,4.2-.7,5.9-2,1.7-1.4,2.8-3.4,3.5-6.2h8.9c-.9,6.2-3.1,10.6-6.7,13.2-3.5,2.7-7.4,4-11.6,3.9-6,0-10.8-2.2-14.4-6.4-3.6-4.2-5.4-9.9-5.5-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M351.8,303.8c0,7.2-1.9,12.9-5.5,17.1-3.6,4.2-8.4,6.4-14.4,6.5-6.1,0-10.9-2.3-14.5-6.5-3.6-4.2-5.4-9.9-5.5-17.1,0-7.2,1.9-12.9,5.5-17.1,3.6-4.2,8.4-6.4,14.5-6.5,6,0,10.8,2.3,14.4,6.5,3.6,4.2,5.4,9.9,5.5,17.1ZM321.2,303.8c0,4.5,1,8.1,2.9,10.7,1.9,2.7,4.5,4,7.8,4.1,3.3,0,5.9-1.4,7.8-4.1,1.9-2.6,2.8-6.2,2.9-10.7,0-4.5-1-8-2.9-10.6-1.9-2.7-4.5-4-7.8-4.1-3.3,0-5.9,1.4-7.8,4.1-1.9,2.6-2.8,6.2-2.9,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M396.2,303.8c0,7.2-1.9,12.9-5.5,17.1-3.6,4.2-8.4,6.4-14.4,6.5-6.1,0-10.9-2.3-14.5-6.5-3.6-4.2-5.4-9.9-5.5-17.1,0-7.2,1.9-12.9,5.5-17.1,3.6-4.2,8.4-6.4,14.5-6.5,6,0,10.8,2.3,14.4,6.5,3.6,4.2,5.4,9.9,5.5,17.1ZM365.6,303.8c0,4.5,1,8.1,2.9,10.7,1.9,2.7,4.5,4,7.8,4.1,3.3,0,5.9-1.4,7.8-4.1,1.9-2.6,2.8-6.2,2.9-10.7,0-4.5-1-8-2.9-10.6-1.9-2.7-4.5-4-7.8-4.1-3.3,0-5.9,1.4-7.8,4.1-1.9,2.6-2.8,6.2-2.9,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M418.5,280.8c4.6,0,8.3,1.6,11,4.6,2.8,3,4.2,7,4.3,12.1,0,4.9-1.5,8.9-4.1,11.7-2.7,2.9-6.3,4.4-10.8,4.5h-6.8v13h-9.3v-45.8h15.7ZM418.9,305.3c1.7,0,3.2-.8,4.3-2.2,1.1-1.4,1.7-3.4,1.7-5.9,0-2.4-.6-4.3-1.7-5.7-1.1-1.4-2.5-2.1-4.3-2.2h-7v15.9h7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.56e0e12afea91b0884be3d4c84d37ffc.svg";
export { ForwardRef as ReactComponent };